import { companyService } from '@/data/services/company/company-service'
import { CompanyGeneral, CompanyInfoDetail } from '@/data/services/company/company-service-types'
import { queryClient } from '@/infra/http'

/** Query key das informações da empresa — compartilhada entre loader e update. */
export const companyInfoDetailQueryKey = (id: string) => ['company-info-detail', id]

/** Query key dos dados gerais — compartilhada entre loader e ações de block/churn. */
export const companyGeneralQueryKey = (id: string) => ['company-general', id]

export type CompanyDetailLoadDataType = {
  infoDetail: CompanyInfoDetail
  general: CompanyGeneral
}

export async function loadCompanyDetail(id: string): Promise<CompanyDetailLoadDataType> {
  // `general` (nome + ativa/bloqueada) alimenta o header e as ações de status,
  // independente da tab — carregado junto do infoDetail.
  const [infoDetail, general] = await Promise.all([
    queryClient.fetchQuery({
      queryKey: companyInfoDetailQueryKey(id),
      queryFn: () => companyService.fetchCompanyInfoDetail(id),
      staleTime: 1000 * 60 * 5
    }),
    queryClient.fetchQuery({
      queryKey: companyGeneralQueryKey(id),
      queryFn: () => companyService.fetchCompanyGeneral(id),
      staleTime: 1000 * 60 * 5
    })
  ])
  return { infoDetail, general }
}
